import { getLooks, getNextLookUrlSlug, getPageByUrlSlug } from "@lib/kontent"
import { LookDetailPage } from "@lib/kontent/models-deprecated/look_detail_page"
import { PageProps } from "@lib/types"
import { ErrorPage } from "@screens/error"
import LookDetail from "@screens/looks/detail"
import { NextPage } from "next"

type Props = PageProps<{
  content: LookDetailPage
  otherLooks: LookDetailPage[]
  nextLookUrlSlug: string
}>

const Page: NextPage<Props> = ({ statusCode, data }) => {
  if (statusCode) {
    return <ErrorPage statusCode={statusCode} />
  }
  if (!data || !data.content) {
    return <ErrorPage statusCode={404} />
  }

  return (
    <LookDetail
      content={data.content}
      otherLooks={data.otherLooks}
      nextLookUrlSlug={data.nextLookUrlSlug}
    />
  )
}

Page.getInitialProps = async ({ lang, query }) => {
  try {
    const content = (await getPageByUrlSlug({
      type: "look_detail_page",
      urlSlug: query.uid as string,
      lang,
    })) as LookDetailPage
    const otherLooks = await getLooks({ limit: 5, lang })
    const nextLookUrlSlug = await getNextLookUrlSlug({
      afterDate: content.system.lastModified.toISOString(),
      lang,
    })

    if (!content) {
      return { statusCode: 404 }
    }

    return {
      data: {
        content: content as LookDetailPage,
        otherLooks: otherLooks.items.filter(
          (item) => item.urlSlug.value !== query.uid
        ),
        nextLookUrlSlug,
      },
    }
  } catch (error) {
    console.error(error)
    return { statusCode: 500 }
  }
}

export default Page
